<template>
  <!-- Desktop version -->
  <RouterLink to="/company" class="hidden new_lg:block col-start-1 col-end-4 row-start-1 row-end-[5]">
    <Motion as="div"
      :initial="{ opacity: 0, y: 20, background: 'linear-gradient(135deg, #000 0%, #000 50%, #000 100%)' }"
      :animate="{ opacity: 1, y: 0, background: 'linear-gradient(135deg, #000 0%, #000 50%, #000 100%)' }" :whileHover="{
        background: 'linear-gradient(135deg, #1BA494 0%, #067D68 50%, #000 100%)',
        transition: {
          duration: 0.3,
          ease: 'easeOut'
        }
      }" :transition="{
        duration: 0.5,
        ease: 'easeOut'
      }"
      class="rounded-[20px] px-6 py-4 new_lg:px-10 new_lg:py-8 cursor-pointer relative h-full flex flex-col justify-center"
      @mouseenter="isHovered = true" @mouseleave="isHovered = false">
      <!-- 우측 상단: B2B SI 개발 및 테스트 전문기업 리드워크 -->

      <!-- 좌측: LEADWALK -->
      <div class="relative flex my-auto">
        <Motion as="p" :animate="{ scale: isHovered ? 1.05 : 1 }" :transition="{ duration: 0.5, ease: 'easeOut' }"
          class="font-extrabold font-paperlogy tracking-tighter leading-[0.82] text-white new_lg:text-[140px] new_xl:text-[160px] new_2xl:text-[200px]">
          LEAD
          <br>
          &nbsp;&nbsp;&nbsp;WALK
        </Motion>

        <div class="absolute right-0 top-0 bottom-0 flex flex-col justify-end items-end">
          <div class="absolute right-0 top-0 text-white text-right flex items-center align-middle">
            <p class="font-basic new_lg:text-xl new_xl:text-3xl new_2xl:text-4xl whitespace-nowrap">B2B SI 개발 및 테스트 전문기업<br/><strong class="new_lg:text-2xl new_xl:text-4xl new_2xl:text-5xl">리드워크</strong></p>
          </div>
          <div>
            <button class="bg-white text-black font-medium px-4 py-3 rounded-full hover:bg-gray-100 transition-colors text-sm lg:text-xl 2xl:text-2xl flex items-center gap-8 whitespace-nowrap">
              회사소개
              <div class="bg-black rounded-full p-1 flex items-center justify-center">
                <img :src="require('@/assets/ic-arrow-horizontal-white.png')" alt="arrow"
                  class="w-3 h-3 new_lg:w-6 new_lg:h-6" />
              </div>
            </button>
          </div>

        </div>
      </div>

      <!-- 우측 하단: 회사소개 버튼 -->
      <!-- <div class="absolute bottom-4 right-6 new_lg:bottom-8 new_lg:right-10">
      <button
        class="bg-white text-black font-bold px-4 py-2 rounded-full hover:bg-gray-200 transition-colors text-sm new_lg:text-base flex items-center gap-2"
      >
        회사소개
        <div class="bg-black rounded-full p-1 flex items-center justify-center ml-2">
          <img
            :src="require('@/assets/ic-arrow-horizontal-white.png')"
            alt="arrow"
            class="w-3 new_lg:w-4 new_lg:h-4"
            style="aspect-ratio: 40/25; object-fit: contain;"
          />
        </div>
      </button>
    </div> -->
    </Motion>
  </RouterLink>

  <!-- Mobile -->
  <RouterLink to="/company" class="new_lg:hidden">
    <Motion as="div"
      :initial="{ opacity: 0, y: 20, background: 'linear-gradient(135deg, #000 0%, #000 50%, #000 100%)' }"
      :animate="{ opacity: 1, y: 0, background: 'linear-gradient(135deg, #000 0%, #000 50%, #000 100%)' }" :whileHover="{
        scale: 1.02,
        background: 'linear-gradient(135deg, #1BA494 0%, #067D68 50%, #000 100%)',
        transition: {
          duration: 0.3,
          ease: 'easeOut'
        }
      }" :transition="{
        duration: 0.5,
        ease: 'easeOut'
      }" class="relative rounded-[20px] cursor-pointer flex flex-col p-4" @mouseenter="isHoveredMobile = true"
      @mouseleave="isHoveredMobile = false">
      <!-- 우측 상단: B2B SI 개발 및 테스트 전문기업 리드워크 -->
      <div class="text-white text-left">
        <p class="font-basic font-normal text-xl">B2B SI 개발 및 테스트 전문기업<br /><strong>리드워크</strong></p>
      </div>
      <div class="text-white py-4 flex flex-row">
        <Motion as="p" :animate="{ scale: isHoveredMobile ? 1 : 1 }" :transition="{ duration: 0.5, ease: 'easeOut' }"
          class="font-extrabold font-paperlogy text-left text-6xl tracking-tighter">
          LEAD
          <br />&nbsp;&nbsp;
          WALK
        </Motion>
      </div>

      <!-- 우측 하단: 회사소개 버튼 -->
      <div class="absolute bottom-1/2 translate-y-1/2 right-3 new_sm:right-4 new_lg:bottom-8 new_lg:right-10">
        <button
          class="bg-white text-black font-bold px-4 py-2 rounded-full hover:bg-gray-200 transition-colors text-sm new_lg:text-base flex items-center gap-2">
          회사소개
          <div class="bg-black rounded-full p-1 flex items-center justify-center ml-2">
            <img :src="require('@/assets/ic-arrow-horizontal-white.png')" alt="arrow" class="w-4 h-4"
              style="aspect-ratio: 40/25; object-fit: contain;" />
          </div>
        </button>
      </div>
    </Motion>
  </RouterLink>
</template>

<script setup>
import { Motion } from 'motion-v'
import { ref } from 'vue'

defineProps({
  motionDelay: {
    type: Number,
    default: 0
  }
})

// Hover state
const isHovered = ref(false)
const isHoveredMobile = ref(false)
</script>
